import React from "react";
import { HelpSectionOptions } from "../../../helper/helperFunctions";

function HelpForm({ formData, setFormData }: any) {
  let options = HelpSectionOptions;
  return (
    <div>
      <div className="d-flex justify-content-center w-100  align-items-center modal-body-page">
        <select
          className="w-100  border-0 "
          style={{
            background: "#F2F2F2",
            fontWeight: 700,
            color: formData?.sectionName?.length > 0 ? "#404040" : " #8c8c8c",
            paddingTop: ".7rem",
            paddingBottom: ".7rem",
          }}
          onChange={(e) => {
            setFormData({ ...formData, sectionName: e?.target?.value });
          }}
          value={formData?.sectionName}
        >
          {/* <option value="" disabled hidden style={{ color: "#8c8c8c !important" }}> */}
          <option value="" disabled hidden>
            Select Section
          </option>
          {options?.map((item: any, index: any) => {
            return (
              <option key={index} value={item?.label} style={{ color: "#333333", fontWeight: 500, fontSize: 14 }}>
                {item?.label}
              </option>
            );
          })}
        </select>
      </div>
      <div className="mt-2 modal-body-page" style={{ paddingTop: "1rem" }}>
        <input
          type="text"
          className="w-50 short-select-field"
          placeholder="Enter english page name"
          value={formData?.pageName}
          onChange={(e) => setFormData({ ...formData, pageName: e?.target?.value })}
          style={{ background: "#F2F2F2", paddingBottom: ".3rem", minHeight: "40px" }}
        />
      </div>
      <div className="mt-2 modal-body-page" style={{ paddingTop: "1rem" }}>
        <input
          type="text"
          className="w-50 short-select-field"
          placeholder="Enter arabic page name"
          value={formData?.arabicPageName}
          onChange={(e) => setFormData({ ...formData, arabicPageName: e?.target?.value })}
          style={{ background: "#F2F2F2", minHeight: "40px", paddingBottom: ".3rem" }}
        />
      </div>
    </div>
  );
}

export default HelpForm;
